import React from 'react';
import { Typography, Row, Col, Button, Space } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import LogoutButton from './logoutButton'; // Make sure this exists in your crew
import './css/UnderMaintenance.css'; // Create this CSS file for styling

const { Title, Text } = Typography;

const UnderMaintenance = () => {
  return (
    <Row justify="center" align="middle" className="maintenance-row">
      <Col xs={22} sm={20} md={16} lg={12} xl={10}>
        <div className="frame">
          <Space direction="vertical" size="large" align="center" style={{ width: '100%' }}>
            <ToolOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />
            <Title level={2} className="custom-title">Campaign Fabricator - Under Maintenance</Title>
            <Text className="text-secondary" style={{ textAlign: 'center' }}>
              Ahoy! We be battening down the hatches and patchin’ the sails. The system’s under scheduled maintenance.
              Please check back soon—we’ll be sailin’ smooth waters again before ye know it.
            </Text>

            <Text className="text-primary">
              In the meantime, feel free to visit our main site or logout below.
            </Text>

            <a
              href="https://campaignfabricator.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange"
            >
              Visit CampaignFabricator.com
            </a>

            <div className="user-actions" style={{ marginTop: '16px' }}>
              <LogoutButton>Logout</LogoutButton>
            </div>
          </Space>
        </div>
      </Col>
    </Row>
  );
};

export default UnderMaintenance;
